import { ChangeDetectorRef, Component, Input, output, inject } from '@angular/core';
import type { UntypedFormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import type { User, UserBase, UserWithRole } from '@core/account-types';
import { TranslatePipe } from '@core/i18n-legacy';
import {
  IconButtonComponent,
  DividerComponent,
  TruncateComponent,
  HeadingComponent,
  AvatarComponent,
  CheckboxComponent,
} from '@core/user-interface-legacy';

import type { RoleWithAdmins } from '../../../types';

@Component({
  selector: 'rt-visibility-admin-item',
  templateUrl: 'visibility-admin-item.component.html',
  styleUrls: ['./visibility-admin-item.component.less'],
  imports: [
    CheckboxComponent,
    ReactiveFormsModule,
    AvatarComponent,
    HeadingComponent,
    TruncateComponent,
    DividerComponent,
    IconButtonComponent,
    TranslatePipe,
  ],
})
export class VisibilityAdminItemComponent {
  private readonly cdRef = inject(ChangeDetectorRef);

  @Input() public admin: UserWithRole;
  @Input() public currentAdmin: UserBase;
  @Input() public hasDivider: boolean = false;
  @Input() public hasNoBorderBottom: boolean = false;
  @Input() public hasPadding: boolean = false;
  @Input() public hasCheckboxOffset: boolean = false;
  @Input() public kind: 'admin' | 'role' | 'simple-admin' | 'no-access' = 'admin';
  @Input() public form: UntypedFormControl | null;
  @Input() public checked: false | number;
  @Input() public roleWithAdmins: RoleWithAdmins | null = null;
  @Input() public roleAssignmentsGroup: { [roleId: string]: number | false } | null = null;
  @Input() public groupUsersByAccess = false;

  public checkboxClick = output<void>();
  public toggleAssignment = output<User | RoleWithAdmins>();

  public expanded: boolean = false;

  public toggleList($event: MouseEvent): void {
    $event.stopPropagation();
    this.expanded = !this.expanded;
    this.cdRef.detectChanges();
  }

  public trackById<T extends { id: number }>(index: number, { id }: T): number {
    return id;
  }
}
